import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class BankAccount {

  @JsonProperty()
  id: number = -1;
  @JsonProperty()
  ownerCode: string | undefined;
  @JsonProperty()
  bankAccountCode: string | undefined;
  @JsonProperty()
  accountNumber: string | undefined;
  @JsonProperty()
  swiftAccount: string | undefined;
  @JsonProperty()
  accountName: string | undefined;
  @JsonProperty()
  fedWire: string | undefined;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
